export async function fetchAudio(text) {
    const res = await fetch(`https://tts-api-gateway.deno.dev?text=${text}`).catch(e => {
        throw new Error(e);
    });
    return await res.blob();
}
